module.exports = __webpack_public_path__ + "img/1.fad21f28.jpeg";